import { render, staticRenderFns } from "./PhoneNumberDatabase.vue?vue&type=template&id=b6e85ab0&scoped=true"
import script from "./PhoneNumberDatabase.vue?vue&type=script&lang=js"
export * from "./PhoneNumberDatabase.vue?vue&type=script&lang=js"
import style0 from "./PhoneNumberDatabase.vue?vue&type=style&index=0&id=b6e85ab0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e85ab0",
  null
  
)

export default component.exports